export default "__VITE_ASSET__Bs4e9_s1__"